import { ApplicationCase } from './application-case.model';
import { BranchGroup } from './branch-group.model';
import { BranchUser } from './branch-user.model';

export class Branch {
  public BranchID: number;
  public PropositionID?: number;
  public BranchLocationIdentifier: string;
  public BranchName: string;
  public BranchType: string;
  public Address1: string;
  public Address2: string;
  public Town: string;
  public PostCode: string;
  public BranchStatus: string;
  public PhoneNumber: string;
  public ApplicationCases: Array<ApplicationCase>;
  public BranchUsers: Array<BranchUser>;
  public BranchGroups: Array<BranchGroup>;
  public BranchUsers1: Array<BranchUser>;
}
